import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';

export const FiBusinessUnitStateResolvePageTitle = [
    PageTitleService,
    'businessUnit',
    FiBusinessUnitStateResolvePageTitle_resolveFunc,
];

export function FiBusinessUnitStateResolvePageTitle_resolveFunc(pageTitleService: PageTitleService, businessUnit) {
    return pageTitleService.setTitleByItem(businessUnit);
}
